import { useState } from "react"
import { 
  Box,
  Divider,
} from "@mui/material"
import { useTranslation } from "react-i18next";
import VerticalMenuNavigation from "./VerticalMenuNavigation";
import VerticalMenuSearch from "./VerticalMenuSearch";
import VerticalMenuHeader from "./VerticalMenuHeader";
import VerticalMenuFooter from "./Footer"
import useLayout from "@/features/layout/useLayout";
const VerticalMenuContent = () => {
  const { t } = useTranslation();
  const { isMobile } = useLayout();
  const [searchQuery, setSearchQuery] = useState('');
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      <VerticalMenuHeader />
      {isMobile ? (
        <VerticalMenuSearch
          value={searchQuery}
          onChange={setSearchQuery}
          placeholder={t('search')}
        />
      ) : null}
      <VerticalMenuNavigation
        searchQuery={searchQuery}
      />
      <Divider />
      <VerticalMenuFooter />
    </Box>
  )
}

export default VerticalMenuContent;